/*
Adding middleware as individual route guard(beforeRouteEnter does not support updating state)
https://stackoverflow.com/questions/58496743/in-component-navigation-guard-callback-not-working-nuxt-js-and-beforerouteente
*/

export default async () => {
  const nuxtApp = useNuxtApp();
  const store = nuxtApp.$store;
  const router = useRouter();

  router.afterEach(() => {
    store.commit('setAppLoadingFlag', true);
  });

  router.beforeEach((to, from, next) => {
    store.commit('updatePreviousState', from);
    next();
  });
};
